import {
	getFailureDefinitions,
	getFailureDefinitionsResolved,
	getFailureDefinitionsRejected,
	getDeteriorationModels,
	getDeteriorationModelsResolved,
	getDeteriorationModelsRejected,
} from '@Actions/pipeDeterioration.actions';
import { createReducer } from '@reduxjs/toolkit';
import { PipeDeteriorationStoreState } from '@Types/pipeDeterioration.types';
import { AnyAction } from 'redux';

export const initState: PipeDeteriorationStoreState = {
	failureDefinitions: [],
	deteriorationModels: [],
};

interface PipeDeteriorationReducer {
	[x: string]: (
		state: PipeDeteriorationStoreState,
		action: AnyAction,
	) => PipeDeteriorationStoreState | undefined;
}

export const reducer: PipeDeteriorationReducer = {
	[getFailureDefinitions.toString()]: state => ({
		...state,
	}),
	[getFailureDefinitionsResolved.toString()]: (state, action) => ({
		...state,
		failureDefinitions: action.payload.failure_definitions,
	}),
	[getFailureDefinitionsRejected.toString()]: state => ({
		...state,
	}),
	[getDeteriorationModels.toString()]: state => ({
		...state,
	}),
	[getDeteriorationModelsResolved.toString()]: (state, action) => ({
		...state,
		deteriorationModels: action.payload,
	}),
	[getDeteriorationModelsRejected.toString()]: state => ({
		...state,
	}),
};

export const pipeDeteriorationReducer = createReducer(initState, reducer);
